var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "has-text-primary is-size-3 " }, [
          _vm._v("DASHBOARD")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "limitWidth" }, [_c("hr")]),
        _vm._v(" "),
        _c("div", { attrs: { id: "slinksTable wideLimitWidth" } }, [
          _c("div", { staticClass: "is-size-4" }, [
            _vm._v("\n\t\t\t\tYour Subscriptions:\n\t\t\t")
          ]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "bottom10 " },
            [
              _c("tr", { staticClass: "top10 has-text-weight-bold" }, [
                _c("td", { attrs: { width: "10%" } }, [_vm._v("Subcription")]),
                _vm._v(" "),
                _c("td", { attrs: { width: "20%" } }, [_vm._v("Status")]),
                _vm._v(" "),
                _c("td", { attrs: { width: "10%" } }, [_vm._v("Renews")]),
                _vm._v(" "),
                _c("td", { attrs: { width: "10%" } }, [_vm._v(" ")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.subscriptionsArr, function(item, index) {
                return [
                  _c(
                    "tr",
                    { class: { "has-background-light": (index + 1) % 2 } },
                    [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _c("span", { staticClass: "has-text-grey" }, [
                          _vm._v("•")
                        ]),
                        _vm._v(" " + _vm._s(item.id))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "has-text-danger":
                              item.status == _vm.constants.INGRACEPERIOD
                          }
                        },
                        [_vm._v(_vm._s(_vm._f("statusString")(item.status)))]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.az.dateConvert(item.expDate)))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "has-text-right" }, [
                        item.status == _vm.constants.INGRACEPERIOD
                          ? _c(
                              "button",
                              {
                                staticClass: "button is-small is-warning",
                                on: {
                                  click: function($event) {
                                    return _vm.renew(item.id)
                                  }
                                }
                              },
                              [_vm._v("RENEW")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == _vm.constants.ACTIVE
                          ? _c(
                              "button",
                              {
                                staticClass: "button is-small is-warning",
                                on: {
                                  click: function($event) {
                                    return _vm.cancel(item.id)
                                  }
                                }
                              },
                              [_vm._v("REMOVE")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == _vm.constants.CANCELED
                          ? _c(
                              "button",
                              {
                                staticClass: "button is-small is-warning",
                                on: {
                                  click: function($event) {
                                    return _vm.reinstate(item.id)
                                  }
                                }
                              },
                              [_vm._v("REINSTATE")]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      staticClass: "slctTableRow trBorder",
                      class: { "has-background-light": (index + 1) % 2 }
                    },
                    [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "3" } },
                        [
                          _c(
                            "i",
                            {
                              staticClass:
                                "has-text-weight-bold is-size-7 contentsLabel",
                              on: {
                                click: function($event) {
                                  return _vm.toggleHidden(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-play faSmall",
                                class: { rotate: item.show },
                                attrs: { id: "tri" + index }
                              }),
                              _vm._v("Contents")
                            ]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade2" } }, [
                            _c(
                              "table",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.show,
                                    expression: "item.show"
                                  }
                                ],
                                staticClass: "is-italic is-size-7",
                                attrs: { width: "100%", id: "table" + index }
                              },
                              [
                                _vm._l(item.contents, function(line, i) {
                                  return _c(
                                    "tr",
                                    {
                                      key: line.id,
                                      staticClass: "trHeightShort",
                                      class: {
                                        "has-background-white": (i + 1) % 2,
                                        "has-background-light": i % 2
                                      }
                                    },
                                    [
                                      _c("td", { attrs: { width: "40%" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "has-text-weight-bold"
                                          },
                                          [_vm._v(_vm._s(line.slink) + ":")]
                                        ),
                                        _vm._v(
                                          " $" +
                                            _vm._s(line.cost) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(line.subsQ) +
                                            " Subslink Packs: $" +
                                            _vm._s(line.subsCost) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "has-text-right" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\tTotal: $" +
                                              _vm._s(line.total) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button is-small is-pulled-right slinkEditBt",
                                            on: {
                                              click: function($event) {
                                                return _vm.goToDetail(
                                                  line.slink
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("MANAGE")]
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c("tr", { staticClass: "trHeightShort" }, [
                                  _c("td", [
                                    item.status == _vm.constants.INGRACEPERIOD
                                      ? _c("span", { staticClass: "tdTop" }, [
                                          _c("br"),
                                          _vm._v(
                                            "*If you would like to change the contents of this subscription before renewing it, click on the MANAGE buttons next to each item"
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("br"),
                                    _c("br")
                                  ]),
                                  _vm._v(" "),
                                  _c("td"),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "has-text-right has-text-weight-bold"
                                    },
                                    [
                                      _vm._v("$" + _vm._s(item.total)),
                                      _c("br"),
                                      _c("br")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td")
                                ])
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d81e2c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d81e2c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = null
// module chunks = 